import {
  REKAP_TRANSAKSI,
  SIMPANAN_SUKARELA,
} from "../../constants/admin/masterdata/constants";

const initialState = {
  isModalAction: false,
  loadingGetSimpananSukarela: true,
  loadingActionSimpananSukarela: false,
  dataSimpananSukarela: { count: 0, data: [] },
  selectedIds: [],
  queryKey: null,
  cache: {}, // {[key]: { data: {count, data: []}, fetchedAt, loading? }}
};

export const simpananSukarelaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMPANAN_SUKARELA.GET_DATA_SIMPANAN_SUKARELA_SUCCESS:
      return {
        ...state,
        dataSimpananSukarela: action.data,
      };

    case SIMPANAN_SUKARELA.LOADING_DATA_SIMPANAN_SUKARELA_SUCCESS:
      return {
        ...state,
        loadingGetSimpananSukarela: action.load,
      };

    case SIMPANAN_SUKARELA.LOADING_ACTION_SIMPANAN_SUKARELA:
      return {
        ...state,
        loadingActionSimpananSukarela: action.load,
      };

    case SIMPANAN_SUKARELA.IS_MODAL_ACTION_SIMPANAN_SUKARELA:
      return {
        ...state,
        isModalAction: action.load,
      };

    // Selection
    case SIMPANAN_SUKARELA.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case SIMPANAN_SUKARELA.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case SIMPANAN_SUKARELA.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case SIMPANAN_SUKARELA.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    // Cache
    case SIMPANAN_SUKARELA.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataSimpananSukarela: data,
        loadingGetSimpananSukarela: false,
      };
    }

    case SIMPANAN_SUKARELA.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetSimpananSukarela: loading,
      };
    }

    case SIMPANAN_SUKARELA.UPDATE_CACHE_ITEMS: {
      const { changesById } = action; // { [id]: { ...partial } }
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataSimpananSukarela?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row
      );
      return {
        ...state,
        cache: nextCache,
        dataSimpananSukarela: {
          ...state.dataSimpananSukarela,
          data: newActive,
        },
      };
    }

    default:
      return state;
  }
};
